<template>
	<Overlay class="vote-view">
		<HiqHeader @click="onHome" />
		<Vote @submitted="onSubmitted" />
		<Modal v-if="exitModal" @close="exitModal = false">
			<h2>Hold on!</h2>
			<p>
				You've got <strong>{{ votesLeftText }}</strong> left to vote on! Your
				votes won't count until you're done.
			</p>
			<button class="btn" @click="onExit">Exit anyway</button>
		</Modal>
	</Overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import Overlay from '@/views/Overlay'
import HiqHeader from '@/components/shared/HiqHeader'
import Vote from '@/components/vote/Vote'
import Modal from '@/components/admin/Modal'

export default {
	name: 'VoteView',
	data() {
		return {
			exitModal: false
		}
	},
	computed: {
		...mapGetters({
			submissionsLeft: 'session/submissionsLeft'
		}),
		votesLeftText() {
			const s = this.submissionsLeft === 1 ? '' : 's'
			return `${this.submissionsLeft} submission${s}`
		}
	},
	methods: {
		onHome() {
			this.exitModal = true
		},
		onExit() {
			this.$router.push({ name: 'Home' })
		},
		onSubmitted(success) {
			const name = success ? 'Voted' : 'Home'
			this.$router.push({ name })
		}
	},
	components: {
		Overlay,
		HiqHeader,
		Vote,
		Modal
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.vote-view {
	@extend %flex-col;
	background: $gradient-orange;
	overflow: hidden;
}

.btn {
	@include button;
	@include mq-max(md) {
		width: 100%;
	}
}
</style>
